(function () {
  var noeud = document.getElementById('lige-cadeau-config');
  if (!noeud) return;
  var cfg; try { cfg = JSON.parse(noeud.textContent); } catch (e) { return; }

  var VARIANT   = cfg.variant;
  var EXCLUS    = [cfg.produit];
  var SEUIL     = cfg.seuil || 2;
  var RECHARGER = !!cfg.recharger;
  var T         = cfg.textes || {};
  var SELECTEURS = ['cart-items-component','.cart-drawer__content','#main-cart-items',
                    'cart-drawer-items','#CartDrawer-CartItems','.cart__items',
                    '.drawer__inner','form[action*="/cart"]'];

  function txt(s, secours){ return (!s || /translation missing/i.test(s)) ? secours : s; }
  var MSG_PROCHE = txt(T.proche,      'One more watch and your storage box is free.');
  var MSG_OK     = txt(T.ok,          'Your storage box is free.');
  var MSG_TOAST  = txt(T.toast,       'Storage box added. It is on us.');
  var LABEL      = txt(T.label,       'Gift');
  var LABEL_VAL  = txt(T.labelValeur, 'Free with 2 watches');

  var occupe = false, dejaVu = false, dernierNb = 0, attente = null, panierCache = null;
  var JSON_H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function panier(){ return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function nbMontres(c){
    return c.items.reduce(function (n, i) {
      return EXCLUS.indexOf(i.product_id)!==-1||i.gift_card?n:n+i.quantity
    }, 0);
  }
  function cadeau(c){ return c.items.filter(function (i) { return i.variant_id === VARIANT; })[0] || null; }

    function message(montres){
    var etat = montres >= SEUIL ? 'ok' : (montres === SEUIL - 1 ? 'proche' : 'rien');
    var ex = document.querySelector('.lige-cadeau-msg');
    if (etat === 'rien') { if (ex) ex.remove(); return; }

    // Cible prioritaire : le bloc "Estimated total" du tiroir
    var cible = document.querySelector('cart-drawer-component .cart-drawer__summary');
    for (var i = 0; i < SELECTEURS.length && !cible; i++) cible = document.querySelector(SELECTEURS[i]);
    if (!cible) return;

    // Déjà en place et à jour : rien à faire
    if (ex && ex.isConnected && ex.parentNode === cible && ex.getAttribute('data-etat') === etat) return;
    if (ex) ex.remove();

    var el = document.createElement('div');
    el.className = 'lige-cadeau-msg';
    el.setAttribute('data-etat', etat);
    el.textContent = etat === 'ok' ? MSG_OK : MSG_PROCHE;
    cible.insertBefore(el, cible.firstChild);
  }

  function toast(texte){
    var t = document.createElement('div');
    t.className = 'lige-toast';
    t.textContent = texte;
    document.body.appendChild(t);
    setTimeout(function(){ t.classList.add('lige-toast--on'); }, 10);
    setTimeout(function(){ t.classList.remove('lige-toast--on');
      setTimeout(function(){ t.remove(); }, 400); }, 4500);
  }

  // Rafraîchit le panier via l'événement natif d'Horizon, sans ouvrir le tiroir.
  function rafraichir(){
    if (RECHARGER) { window.location.reload(); return; }
    var auto = document.querySelectorAll('cart-drawer-component[auto-open]');
    for (var i = 0; i < auto.length; i++) auto[i].removeAttribute('auto-open');

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: panierCache,
        sourceId: 'lige-cadeau',
        data: { itemCount: panierCache ? panierCache.item_count : 0, source: 'lige-cadeau' }
      }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); // autres thèmes

    setTimeout(function () {
      for (var j = 0; j < auto.length; j++) auto[j].setAttribute('auto-open', '');
    }, 0);
    setTimeout(function () { message(dernierNb); }, 500);
  }

  function sync(){
    if (occupe) return Promise.resolve(false);
    occupe = true;
    return panier().then(function (c) {
      panierCache = c;
      var montres = nbMontres(c), ligne = cadeau(c);
      var aNous = !!(ligne && ligne.properties && ligne.properties._gift === '1');
      if (aNous) dejaVu = true;
      dernierNb = montres;

      if (montres >= SEUIL && !ligne) {
        if (sessionStorage.getItem('cadeau_refuse') === '1') return false;
        if (dejaVu) { sessionStorage.setItem('cadeau_refuse', '1'); return false; }
        var p = { _gift: '1' };
        p[LABEL] = LABEL_VAL;
        return fetch('/cart/add.js', { method: 'POST', headers: JSON_H,
          body: JSON.stringify({ items: [{ id: VARIANT, quantity: 1, properties: p }] })
        }).then(function () { dejaVu = true; toast(MSG_TOAST); return panier(); })
          .then(function (c2) { panierCache = c2; dernierNb = nbMontres(c2); return true; });
      }

      if (montres < SEUIL && aNous) {
        return fetch('/cart/change.js', { method: 'POST', headers: JSON_H,
          body: JSON.stringify({ id: ligne.key, quantity: 0 })
        }).then(function () { return panier(); })
          .then(function (c2) { panierCache = c2; dernierNb = nbMontres(c2); return true; });
      }
      return false;
    }).catch(function () { return false; })
      .then(function (m) { occupe = false; message(dernierNb); return m; });
  }

  function lancer(){ sync().then(function (m) { if (m) rafraichir(); }); }

  lancer();

  new MutationObserver(function () {
    if (attente) return;
    attente = setTimeout(function () { attente = null; message(dernierNb); }, 150);
  }).observe(document.body, { childList: true, subtree: true });

  var URLS = /\/cart\/(add|change|update|clear)/;
  var fetchOrigine = window.fetch;
  window.fetch = function () {
    var u = arguments[0] && (arguments[0].url || arguments[0]);
    var p = fetchOrigine.apply(this, arguments);
    if (typeof u === 'string' && URLS.test(u)) p.then(function () { setTimeout(lancer, 250); }).catch(function () {});
    return p;
  };
})();